import { CandidateOnsiteInterviewAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import type { IGetCandidateOnsiteInterviewListPayload, IGetCandidateOnsiteInterviewListResult } from '../types';

export const getCandidateOnsiteInterviewList = async (
  payload: IGetCandidateOnsiteInterviewListPayload,
): Promise<IGetCandidateOnsiteInterviewListResult> => {
  const response = await PermanentJobsApi.getCandidateOnsiteInterviewList(payload);
  return CandidateOnsiteInterviewAdapters.toGetCandidateOnsiteInterviewListResult(response);
};
